import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { CoreComponent } from './core.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RouterModule } from '@angular/router';
import { CoreRoutingModule } from './core.routing';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { PassRestoreComponent } from './pass-restore/pass-restore.component';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component'
import {MatDialogModule} from '@angular/material/dialog';
import { SharedMaterialModule } from '../shared/material/material.module';
import { PocComponent } from './poc/poc.component';
import { httpInterceptorProviders } from '../intercepter';
import { HomeComponent } from './home/home.component';

import { NgxAdalModule } from 'ngx-adal-8';
import { environment } from 'src/environments/environment';
import { MsalService } from '../services/msal.service';
import { UserTypeComponent } from './user-type/user-type.component';
import { Utility } from '../async/utility';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@NgModule({

  declarations: [
    CoreComponent, NotFoundComponent, LoginComponent, ForgotPasswordComponent, ForgotUsernameComponent,
    NotFoundComponent, PocComponent, HomeComponent, UserTypeComponent, ResetPassComponent, PassRestoreComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    SharedModule,
    CoreRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    SharedMaterialModule,
    ToastrModule.forRoot({
      timeOut: 10000,
      extendedTimeOut: 10000,
    }),
    NgxUiLoaderModule
  ],
  providers: [httpInterceptorProviders, MsalService, Utility],
  entryComponents: [ResetPassComponent]
})
export class CoreModule { }
